import { createContext, useContext } from 'react';

export const PartnerPromoModalsContext = createContext({
  holidayHoursModalVisible: false,
  setHolidayHoursModalVisible: () => {},
  isLoyaltyModalOpen: false,
  setIsLoyaltyModalOpen: () => {},
  isDoubleChargeRefundModalOpen: false,
});

export const usePartnerPromoModals = () => useContext(PartnerPromoModalsContext);
